import React from 'react';
import { useIntl } from 'react-intl';
import { DictionaryEvidence, EmptyComponent, Evidence } from '@eas/common-web';
import { DefectType } from '@models';
import { EvidenceApiUrl } from '@enums';
import { useColumns } from './defect-type-columns';
import { Fields } from './defect-type-fields';

export function DefectTypes() {
  const intl = useIntl();
  const columns = useColumns();

  const evidence = DictionaryEvidence.useDictionaryEvidence<DefectType>({
    identifier: 'DEFECT_TYPE',
    version: 5,
    apiProps: {
      url: EvidenceApiUrl.DEFECT_TYPES,
    },
    tableProps: {
      columns,
      tableName: intl.formatMessage({
        id: 'ZSD__DEFECT_TYPE__TABLE__TITLE',
        defaultMessage: 'Typy nedostatkov',
      }),
      showBulkActionButton: false,
      showReportButton: false,
      defaultSorts: [],
    },
    detailProps: {
      toolbarProps: {
        title: intl.formatMessage({
          id: 'ZSD__DEFECT_TYPE__DETAIL__TITLE',
          defaultMessage: 'Typ nedostatku',
        }),
        subtitle: (type) => type?.name ?? '',
        showBtn: () => false,
      },
      GeneralFieldsComponent: EmptyComponent,
      FieldsComponent: Fields,
    },
  });

  return <Evidence {...evidence} />;
}
